angular.module('impactx.catalog').controller('CatalogQualityManagementCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    '$window',
    '$config',
    '$securityManager',
    'ToastService',
    'ConfirmationService',
    '$mdDialog',
    'CatApprovalService',
    '$redirect',
    'CatalogCheckinService',
    '$route',
    'TranslationService',
    'ShopViewService',
    'CatalogActionsService',
    'DownloadService',
    'ToolbarService',
    'NewWindowService',
    CatalogQualityManagementCtrl]);

function CatalogQualityManagementCtrl($scope, dataGen, $routeParams, $window, $config, $securityManager, ToastService, ConfirmationService,
                                      $mdDialog, CatApprovalService, $redirect, CatalogCheckinService, $route, TranslationService,
                                      ShopViewService, CatalogActionsService, DownloadService, ToolbarService, NewWindowService) {
    var self = this;

    self.redirectToCatList = function () {
        $redirect.redirectTo(null, "/cataloglist");
    };

    self.isInitialized = function () {
        return $scope.data.id > 0;
    };

    self.canCheckout = function () {
        return impactX.isDefined($scope, "data.canCheckout");
    };

    self.canReview = function () {
        return impactX.isDefined($scope, "data.canReview");
    };

    self.getReviewLink = function () {
        return "checkedoutcataloglist/" + $scope.data.id;
    };

    self.canExport = function () {
        return impactX.isDefined($scope, "data.canExport");
    };

    self.getCatalogExportLink = function () {
        return "catalogexport/" + $scope.data.id;
    };

    self.canAccessShopView = function () {
        return impactX.isDefined($scope, "data.canAccessShopView");
    };

    self.activateShopView = function () {
        ShopViewService.activateShopView({id: $scope.data.vcatId});
    };

    self.canPrintProtocol = function () {
        return impactX.isDefined($scope, "data.hasCheckLog") && impactX.isDefined($scope, "data.ruleId");
    };

    self.canPrintImportProtocol = function () {
        return impactX.isDefined($scope, "data.hasCheckImportLog") && impactX.isDefined($scope, "data.ruleImportId");
    };

    self.downloadChangeProtocol = function () {
        DownloadService.openDownloadPost('/catalog/rule/downloadchangeprotocol', {paramName: "id", paramValue: parseInt($scope.data.changeProtocol.id)})
    };

    self.hasImportLog = function () {
        return impactX.isDefined($scope, "data.hasImportLog");
    };

    self.downloadLog = function () {
        DownloadService.openDownloadPost('/catalog/download/importlog', {paramName: "catId", paramValue: parseInt($scope.data.id)});
    };

    self.canShowCatalogRuleList = function () {
        return self.isInitialized() && !$scope.data.isSupplier;
    }

    self.getCatalogRuleListLink = function () {
        return "catalogrulelist/" + $scope.data.id;
    };

    self.getCatalogRuleCheckListLink = function () {
        if ($scope.data.id === $scope.data.catNewId) {
            return "catalogrulecheckcheckedoutlist/" + $scope.data.id;
        }
        return "catalogrulechecklist/" + $scope.data.id;
    };

    self.checkoutDialog = function (event) {
        CatalogActionsService.checkOut(event, $scope.data.id, $scope.trns);
    };

    (self.getDialogData = function () {
        dataGen.getData($scope, {catId: $routeParams.id}, "/catalog/catalogqualitymanagement").then(function () {
            self.initializeButtons();
        })
    })();

    this.approveTechnical = function(event) {
        CatApprovalService.approveCatalogs([$scope.data.approvalDetailData.atiId], self.redirectToCatList, event);
    };

    this.approveProfessional = function(event) {
        CatApprovalService.approveCatalogs([$scope.data.approvalDetailData.atiId], self.redirectToCatList, event);
    };

    this.deny = function() {
        CatApprovalService.denyCatalogs([$scope.data.approvalDetailData.atiId], self.redirectToCatList);
    };

    this.stop = function (event) {
        CatApprovalService.stopCatalog($scope.data.approvalDetailData.catId, self.redirectToCatList, event);
    };

    this.backToProfessional = function (event) {
        return CatalogActionsService.backToPurchaser(event, $routeParams.id).then(function () {
            self.getDialogData();
        });
    };

    this.abortApprovalProcess = function (event) {
        CatalogActionsService.abortApproval(event, $scope.data.approvalDetailData.catId, $scope.trns);
    };

    this.canAbortApprovalProcess = function () {
        return impactX.isDefined($scope, "data.approvalDetailData.mayAbortApprovalProcess");
    };

    this.canApproveTechnical = function () {
        return impactX.isDefined($scope, "data.approvalDetailData.mayApproveTechnical");
    };

    this.canDeny = function () {
        return impactX.isDefined($scope, "data.approvalDetailData.mayDenyTechnical") ||
            impactX.isDefined($scope, "data.approvalDetailData.mayDenyProfessional");
    };

    this.canApproveProfessional = function () {
        return impactX.isDefined($scope, "data.approvalDetailData.mayApproveProfessional");
    };

    this.canEditProductCoding = function () {
        return self.canApproveProfessional() || self.canApproveTechnical();
    };

    this.canStop = function () {
        return impactX.isDefined($scope, "data.approvalDetailData.mayStop");
    };

    this.canSendBackToPurchaser = function () {
        return impactX.isDefined($scope, "data.approvalDetailData.maySendBackToPurchaser");
    };

    this.canCheckIn = function () {
        return impactX.isDefined($scope, "data.canCheckIn");
    };

    this.checkIn = function () {
        var tmpScope = {};
        CatalogCheckinService.checkIn(tmpScope, $scope.data.id).then(function () {
            ToastService.openStandardToast(tmpScope.trns.checkInStarted);
            self.redirectToCatalogList();
        });
    };

    this.canDoneForward = function () {
        return impactX.isDefined($scope, "data.canDoneForward");
    };

    this.doneForward = function () {
        CatApprovalService.forwardToApproval($scope.data.id, self.redirectToCatList);
    };

    this.denyCheckedOut = function () {
        CatalogActionsService.denyCheckedOut($scope.data.id, self.redirectToCatList);
    };

    this.canDenyCheckedOut = function () {
        return impactX.isDefined($scope, "data.canDeny") && !self.canDeny();
    };

    this.canCheckInAndMoveForward = function () {
        return impactX.isDefined($scope, "data.canCheckinAndMoveForward");
    };

    this.checkInAndMoveForward = function () {
        CatApprovalService.checkInAndForwardToApproval($scope.data.id, self.redirectToCatalogList, self.redirectToCatalogList);
    };

    this.redirectToCatalogList = function () {
        $redirect.redirectTo(null, "cataloglist");
    };

    this.delete = function () {
        var dataObj = {
            catId: $scope.data.id
        };
        var tempScope = {};
        return dataGen.postAsForm(tempScope, dataObj, "/catalog/delete").then(function () {
            self.redirectToCatList();
            ToastService.openStandardToast(tempScope.trns.deleteSuccess);
        });
    };

    this.canDiscardFailedImport = function () {
        return impactX.isDefined($scope, "data.canDiscardFailedImport") && !self.canDenyCheckedOut();
    };

    self.getDetailLink = function () {
        if (!$scope.data.isExternal && !$scope.data.isSupplier) {
            return "internalcatalog/" + $scope.data.id;
        }
        else if (!$scope.data.isExternal && $scope.data.isSupplier) {
            return "internalcatalogsupplier/" + $scope.data.id;
        }
        else if ($scope.data.isExternal) {
            return "externalcatalog/" + $scope.data.id;
        }
    };

    self.getProductCodingLink = function () {
        return "productcoding/" + $scope.data.id;
    };

    self.replace = function () {
        CatalogActionsService.replace($scope.data.id);
    };

    self.replaceCatOnApprovalProcess = function (event) {
        CatalogActionsService.replaceOnApprovalProcess(event, $scope.data.id, $scope.trns);
    };

    self.replaceCatOnOwnEdit = function (event) {
        CatalogActionsService.replaceOnOwnEdit(event, $scope.data.id, $scope.trns);
    };

    self.canReplace = function () {
        return $scope.data.canReplace;
    };

    self.canReplaceCatOnApprovalProcess = function () {
        return $scope.data.canReplaceOnApprovalProcess;
    };

    self.canReplaceCatOnOwnEdit = function () {
        return $scope.data.canReplaceOnOwnEdit;
    };

    self.canRunChangeProtocol = function() {
        return $scope.data && $scope.data.changeProtocol && $scope.data.changeProtocol.canRunChangeProtocol;
    };

    self.changeProtocolDialog = function(event) {
        CatalogActionsService.runChangeProtocolDialog(event, $scope.data.id)
    };

    self.initializeButtons = function () {
        $scope.buttonDefinition = [
            {
                label: $scope.trns.details,
                linkFunction: self.getDetailLink,
                type: 'link',
                process: 'Catalog'
            },
            {
                label: "update",
                action: self.replace,
                condition: self.canReplace,
                process: 'SupplierCatalogUpload'
            },
            {
                label: "update",
                action: self.replaceCatOnApprovalProcess,
                condition: self.canReplaceCatOnApprovalProcess,
                process: 'SupplierCatalogUpload'
            },
            {
                label: "update",
                action: self.replaceCatOnOwnEdit,
                condition: self.canReplaceCatOnOwnEdit,
                process: 'SupplierCatalogUpload'
            },
            {
                label: $scope.trns.review,
                linkFunction: self.getReviewLink,
                type: 'link',
                condition: self.canReview
            },
            {
                label: $scope.trns.checkout,
                action: self.checkoutDialog,
                type: 'dialogaction',
                condition: self.canCheckout
            },
            {
                label: $scope.trns.checkin,
                action: self.checkIn,
                type: 'dialogaction',
                condition: self.canCheckIn
            },
            {
                label: $scope.trns.discard,
                action: self.denyCheckedOut,
                type: 'dialogaction',
                condition: self.canDenyCheckedOut
            },
            {
                label: $scope.trns.discard,
                action: self.delete,
                type: 'dialogaction',
                condition: self.canDiscardFailedImport
            },
            {
                label: $scope.trns.doneForward,
                action: self.doneForward,
                type: 'dialogaction',
                condition: self.canDoneForward
            },
            {
                label: $scope.trns.doneForward,
                action: self.checkInAndMoveForward,
                type: 'dialogaction',
                condition: self.canCheckInAndMoveForward
            },
            {
                label: $scope.trns.productCoding,
                linkFunction: self.getProductCodingLink,
                type: 'link',
                condition: self.canEditProductCoding,
                process: "ProductCoding"
            },
            {
                label: $scope.trns.approve,
                action: self.approveProfessional,
                type: 'dialogaction',
                condition: self.canApproveProfessional
            },
            {
                label: $scope.trns.approve,
                action: self.approveTechnical,
                type: 'dialogaction',
                condition: self.canApproveTechnical
            },
            {
                label: $scope.trns.deny,
                action: self.deny,
                type: 'dialogaction',
                condition: self.canDeny
            },
            {
                label: $scope.trns.stop,
                action: self.stop,
                type: 'dialogaction',
                condition: self.canStop
            },
            {
                label: $scope.trns.additionalProfessionalApproval,
                action: self.backToProfessional,
                type: 'dialogaction',
                condition: self.canSendBackToPurchaser
            },
            {
                label: $scope.trns.abortApproval,
                action: self.abortApprovalProcess,
                type: 'dialogaction',
                condition: self.canAbortApprovalProcess
            },
            {
                label: $scope.trns.catalogExport,
                linkFunction: self.getCatalogExportLink,
                type: 'link',
                condition: self.canExport
            },
            {
                label: $scope.trns.shopView,
                action: self.activateShopView,
                type: 'dialogaction',
                condition: self.canAccessShopView,
                process: 'Search'
            },
            {
                label: $scope.trns.catrules,
                linkFunction: self.getCatalogRuleListLink,
                type: 'link',
                condition: self.canShowCatalogRuleList
            },
            {
                label: $scope.trns.catrulechecks,
                linkFunction: self.getCatalogRuleCheckListLink,
                type: 'link',
                condition: self.isInitialized
            },
            {
                label: $scope.trns.printProtocol,
                type: 'print',
                condition: self.canPrintProtocol,
                params: {
                    printToken: $scope.printTokens.log
                }
            },
            {
                label: $scope.trns.printImportProtocol,
                type: 'print',
                condition: self.canPrintImportProtocol,
                params: {
                    printToken: $scope.printTokens.importLog
                }
            },
            {
                label: $scope.trns.downloadLog,
                action: self.downloadLog,
                condition: self.hasImportLog,
                process: 'Catalog'
            },
            {
                label: $scope.trns.changeProtocol,
                action: self.changeProtocolDialog,
                condition: self.canRunChangeProtocol,
                process: 'CatalogRunChangeRules'
            }
        ];
        ToolbarService.setButtons($scope.buttonDefinition);
    };
}